import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    dsn: "https://b12b1d3ce02842b997e8764475746ae6@o188884.ingest.sentry.io/6151136",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.05,
});
// myUndefinedFunction();

import $ from 'jquery';
// import _ from 'underscore';
// global.jQuery = require('jquery');

// 'expose' (or whatever) jquery to be usable by other scripts
window.$ = $;

// Bootstrap stuff https://github.com/twbs/bootstrap/blob/v4.6.1/js/index.js
// import Alert from './src/alert'
// import Button from 'bootstrap/js/src/button'
// import Carousel from 'bootstrap/js/src/carousel'
import Collapse from 'bootstrap/js/src/collapse'
import Dropdown from 'bootstrap/js/src/dropdown'
// import Modal from './src/modal'
// import Popover from './src/popover'
// import Scrollspy from './src/scrollspy'
import Tab from 'bootstrap/js/src/tab'
// import Toast from './src/toast'
// import Tooltip from './src/tooltip'
import Util from 'bootstrap/js/src/util'

import {tns} from 'tiny-slider/src/tiny-slider';
import 'pannellum';

import Navigation from './components/Navigation';

// CHARTJS
// import Chart from 'chart.js/auto'; // Everything
import {
    Chart,
    ArcElement,
    // LineElement,
    // BarElement,
    // PointElement,
    // BarController,
    // BubbleController,
    // DoughnutController,
    // LineController,
    PieController,
    // PolarAreaController,
    // RadarController,
    // ScatterController,
    // CategoryScale,
    // LinearScale,
    // LogarithmicScale,
    // RadialLinearScale,
    // TimeScale,
    // TimeSeriesScale,
    // Decimation,
    // Filler,
    // Legend,
    Title,
    Tooltip,
    // SubTitle
} from 'chart.js';
Chart.register(
    ArcElement,
    // LineElement,
    // BarElement,
    // PointElement,
    // BarController,
    // BubbleController,
    // DoughnutController,
    // LineController,
    PieController,
    // PolarAreaController,
    // RadarController,
    // ScatterController,
    // CategoryScale,
    // LinearScale,
    // LogarithmicScale,
    // RadialLinearScale,
    // TimeScale,
    // TimeSeriesScale,
    // Decimation,
    // Filler,
    // Legend,
    Title,
    Tooltip,
    // SubTitle
);

(function ($) {

    //
    // 2025 styling quick fixes
    //
    $('a.blocklink').each(function (){
        console.log(this);
        $(this).addClass('button').removeClass('blocklink')
            .wrapInner('<span>').find('span')
            .after('<i><img src="/landing-html/assets/images/chevron-double.svg"></i>')
            // .after('<i><img src="data:image/svg+xml,%3Csvg width=\'26\' height=\'20\' viewBox=\'0 0 26 20\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M2.33634 0.324872C1.6364 -0.371442 0.443237 0.125407 0.443237 1.11548V18.8824C0.443237 19.8724 1.6364 20.3657 2.33634 19.6693L11.2869 10.7841C11.7257 10.3489 11.7257 9.6417 11.2869 9.2065L2.33634 0.324872ZM25.2277 9.21013L16.2771 0.328499C15.5772 -0.367815 14.384 0.129034 14.384 1.11911V18.886C14.384 19.8761 15.5772 20.3693 16.2771 19.6766L25.2277 10.7913C25.6665 10.3561 25.6665 9.64895 25.2277 9.21376V9.21013Z\' fill=\'#FAFAFA\'/%3E%3C/svg%3E"></i>')
            // .after('<i><img src=\'data:image/svg+xml;utf8,%3csvg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg"%3e%3cpath d="M2.33634 0.324872C1.6364 -0.371442 0.443237 0.125407 0.443237 1.11548V18.8824C0.443237 19.8724 1.6364 20.3657 2.33634 19.6693L11.2869 10.7841C11.7257 10.3489 11.7257 9.6417 11.2869 9.2065L2.33634 0.324872ZM25.2277 9.21013L16.2771 0.328499C15.5772 -0.367815 14.384 0.129034 14.384 1.11911V18.886C14.384 19.8761 15.5772 20.3693 16.2771 19.6766L25.2277 10.7913C25.6665 10.3561 25.6665 9.64895 25.2277 9.21376V9.21013Z"/%3e%3c/svg%3e\'></i>')
        ;
    })

    //
    // 2021 stuff
    //

    // Make whole block-item_BlockImageLinks clickable
    $('.block-item_BlockImageLinks img')
        .on('click', function (e){
            window.location.href = $(this).parent().find('a').attr('href');
        })
        .attr('role','button');

    // components/Main.js - load partial via ajax (only used on social media timeline/old homepage -- remove once switched to blocks site)
    $('.ajax-fragment').on('ajax_load_trigger ajax_refresh_trigger', function () {
        if ($(this).hasClass('ajax-fragment-done')) return;
        // load external content and trigger re-init of jq plugins
        var ajaxurl = $(this).data('ajax-load-url');
        // console.log(ajaxurl);
        var element = this;
        var timeout = ($(this).data('ajax-load-delay') ? $(this).data('ajax-load-delay') : 10);
        // var ajaxurl = $(this).data('ajax-load-url') + '?' + Math.random();
        window.setTimeout(function () {
            $(element).addClass('ajax-fragment-loading').load(ajaxurl, function () {
                $(element).addClass('ajax-fragment-done').removeClass('ajax-fragment-loading');
                $(element).trigger('init_methods_delayed'); // load
                // $(this).trigger('load');
                // $(document).trigger('ready');
                $(window).trigger('load');
            });
        }, timeout);
    }).each(function () {
        // trigger immediately if necessary
        if (!$(this).data('ajax-load-on') || $(this).data('ajax-load-on') !== 'ajax_load_trigger') {
            $(this).trigger('ajax_load_trigger');
        }
        // allow refresh interval
        if ($(this).data('ajax-load-refresh')) {
            var node = $(this);
            window.setInterval(function () {
                // console.log('refreshing');
                node.trigger('ajax_refresh_trigger');
            }, $(this).data('ajax-load-refresh') * 1000);
        }
    });

    // components/Header.js (moved to Navigation.js) - overlay menu nav
    $('header').each(function () {
        let component = new Navigation(this);
        component.init();
    });

    // components/Header.js - Searchfield hidden somewhere in the Header code sans comment...
    $('.navigation-search__block')
        .on('show.bs.dropdown', function () {
            setTimeout(function() { $('#SiteSearchInput').focus() }, 100);
            $('body #Main').append('<div class="body-overlay"></div>');
            $('.site-search-toggle').addClass('active');
        })
        .on('hidden.bs.dropdown', function () {
            $('.body-overlay').remove();
            $('.site-search-toggle').removeClass('active');
        });

    // components/Hamburgers.js
    let hamburgers = document.querySelectorAll(".hamburger");
    if (hamburgers.length > 0) {
        hamburgers.forEach((hamburger) => {
            hamburger.addEventListener("click", function (e) {
                e.preventDefault();
                // this.classList.toggle("is-active");
                hamburgers.forEach((hamburgerItem) => {
                    hamburgerItem.classList.toggle("is-active");
                    hamburgerItem.blur();
                });
            }, false);
        });
    }

    // // components/DropdownMenu.js
    // $(document).on('click', '.dropdown-menu a.dropdown-toggle, .dropdown-menu a[data-toggle="dropdown"]', function (e) {
    //     e.preventDefault();
    //     if (!$(this).next().hasClass('show')) {
    //         $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
    //     }
    //     var $subMenu = $(this).next('.dropdown-menu');
    //     $subMenu.toggleClass('show');
    //     $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
    //         $('.dropdown-submenu .show').removeClass('show');
    //     });
    //     return false;
    // });

    // components/VideoJs.js
    $(document).on('click', '.video-action-btn', function () {
        let videoBtn = $(this), video = videoBtn.closest('.video-block-container').find('video');
        if (video.hasClass('video-paused')) {
            video[0].play();
        } else {
            video[0].pause();
        }
        videoBtn.find('i').toggleClass('fa-play fa-pause');
        video.toggleClass('video-paused video-playing')
    });

    // components/Main.js - fix youtube vids to be responsive
    $('iframe[src^="https://www.youtube"]').each(function () {
        // While we're at it, try & remove recommended videos
        let vidSource = $(this).attr('src');
        $(this).attr('src', vidSource + (vidSource.indexOf('?') > 0 ? '&rel=0' : '?rel=0') ); // doesn't totally disable but only shows related vids from the same channel (Goflex)
        // $(this).attr('src', $(this).attr('src')+'&playlist=VIDEO_ID&loop=1'); // @TODO (MABE) seems to be a way to totally disable related vids (2021)

        // // wrap this item with a videoWrapper class
        // $(this).wrap('<div class="videoWrapper"></div>');
        var $iframe = $(this).addClass('embed-responsive-item');
        // remove weird Silverstripe wrapper
        if($(this).parent().hasClass('leftAlone')){
            $(this).parent().replaceWith($iframe);
        }
        // calculate ratio
        var aspectRatio = 'custom';
        var width = parseInt( $iframe.attr('width') );
        var height = parseInt( $iframe.attr('height') );
        if(width/height===1) aspectRatio = '1by1';
        if(width/height===4/3) aspectRatio = '4by3';
        if(width/height===16/9) aspectRatio = '16by9';
        if(width/height===21/9) aspectRatio = '21by9';

        var wrapper = $('<div></div>')
            .addClass('embed-responsive embed-responsive-'+aspectRatio)
        if(aspectRatio=='custom'){
            wrapper.css('padding-bottom', `calc(100% / ${width} * ${height})`);
        }
        $(this).wrap(wrapper);
    });

    // Custom 'cases' slider (deferred to onload)
    $(window).on('load', function () {
        // $('.goflex-slider img[loading]').removeAttr('loading');
        $('.goflex-slider').each(function () {
            // Initialize slider
            let sliderEl = this;
            let $slider = $(this);
            $slider.data('activeslide', 0);
            $slider.data('activeslideoffset', 0);
            $slider.data('totalslides', $slider.find('.slider-item').length);
            // $slider.data('$slideritemsholder', $slider.find('.slider-items-holder'));
            let $sliderItemsHolder = $slider.find('.slider-items-holder')
                //     // .css('position', 'relative')
                //     // .css('transition', 'margin-left 600ms ease-in-out')
            ;

            $slider.on('update', function () {
                let activeSlideIndex = $slider.data('activeslide');
                let $activeSlide = $slider.find('.slider-item').removeClass('active').eq(activeSlideIndex).addClass('active');
                let activeSlideOffset = -$activeSlide.position().left;
                $slider.data('activeslideoffset', activeSlideOffset);
                $sliderItemsHolder
                    // .css('margin-left', - $activeSlide.position().left)
                    // .css('transform', `translateX(${newOffset}px)`); // translateX is more efficient than margin-left (less recalculating)
                    .css('transform', `translate3d(${activeSlideOffset}px, 0, 0)`); // apparently translate3d is even more efficient...
            });

            // Prev/Next slider navigation with buttons
            $('.slider-nav-button').on('click', function () {
                // if($slider.data('autorunInterval')) window.clearInterval($slider.data('autorunInterval'));
                $slider.trigger($(this).data('direction'));
            });
            $slider.on('prev', function () {
                let curIndex = $slider.data('activeslide');
                let totalSlides = $slider.data('totalslides');
                $slider.data('activeslide', curIndex > 0 ? curIndex - 1 : totalSlides - 1);
                $slider.trigger('update');
            });
            $slider.on('next', function () {
                let curIndex = $slider.data('activeslide');
                let totalSlides = $slider.data('totalslides');
                $slider.data('activeslide', curIndex < totalSlides - 1 ? curIndex + 1 : 0);
                $slider.trigger('update');
            });

            // Swipe gestures
            $slider.data('swipeStartX', null);
            $slider.data('swipeOffset', null);
            $sliderItemsHolder.mousedown(function () {
                $slider.data('swipeStartX', null);
                $slider.data('swipeOffset', null);
                $sliderItemsHolder
                    .addClass('direct-transform')
                    .mousemove(function (e) {
                        if (!$slider.data('swipeStartX')) {
                            $slider.data('swipeStartX', e.originalEvent.clientX);
                        }
                        $slider.data('swipeOffset', e.originalEvent.clientX - $slider.data('swipeStartX'));
                        let swipeSliderOffset = $slider.data('activeslideoffset') + $slider.data('swipeOffset');
                        $sliderItemsHolder.css('transform', `translate3d(${swipeSliderOffset}px, 0, 0)`);
                        console.log($slider.data('swipeOffset'));
                        // }).mouseup(function (e){
                        //     console.log($slider.data('swipeOffset'));
                        //     if(Math.abs($slider.data('swipeOffset')) > 100) {
                        //         $slider.trigger($slider.data('swipeOffset') < 0 ? 'prev' : 'next');
                        //     } else {
                        //         $slider.trigger('update');
                        //     }
                        //     $slider.data('swipeStartX', null);
                        //     $slider.data('swipeOffset', null);
                    });
            }).mouseup(function () {
                $sliderItemsHolder.unbind('mousemove');
                $sliderItemsHolder.removeClass('direct-transform')
                console.log($slider.data('swipeOffset'));
                if (Math.abs($slider.data('swipeOffset')) > 100) {
                    $slider.trigger($slider.data('swipeOffset') < 0 ? 'next' : 'prev');
                } else {
                    $slider.trigger('update');
                }
                // $slider.data('swipeStartX', null);
                // $slider.data('swipeOffset', null);
            }).mouseout(function () {
                $sliderItemsHolder.unbind('mousemove');
                // $slider.data('swipeStartX', null);
                // $slider.data('swipeOffset', null);
                // }).on('transitionend', function (){
                //     // $sliderItemsHolder.css('transition', 'none');
            });

            // Recalculate on resize
            $(window).on('resize', function () {
                if ($slider.data('updateTimeout')) window.clearTimeout($slider.data('updateTimeout'));
                $slider.data('updateTimeout', window.setTimeout(function () {
                    $slider.trigger('update')
                }, 400));
            });

            // Auto-run unless cursor is over it or page is inactive
            $slider.on('mouseenter', function (evt) {
                $slider.data('hovering', true);
            });
            $slider.on('mouseover', function (evt) {
                $slider.data('hovering', true);
            });
            $slider.on('mouseleave', function (evt) {
                $slider.data('hovering', false);
            });
            $slider.data('autorunInterval', window.setInterval(function () {
                if (!$slider.data('hovering') && !document.hidden) $slider.trigger('next');
            }, 5000));
        });
    });

    // // components/Main.js - Tiny Slider init (used for the showcase slider (Social Media Timeline in Goflex 2021 theme))
    // if ($('.tns-slider').length) {
    //     let slider = tns({
    //         container: '.tns-slider',
    //         // container: '.slider-items-holder',
    //         items: 1,
    //         loop: true,
    //         slideBy: 'page',
    //         speed: 1000,
    //         nav: false,
    //         controls: false,
    //         mouseDrag: true,
    //         autoplay: false,
    //         autoplayButtonOutput: false,
    //         'edgePadding': 0,
    //         'responsive': {
    //             '800': {
    //                 'edgePadding': 0
    //             },
    //             '500': {
    //                 'edgePadding': 0
    //             }
    //         }
    //     });
    //     $(document).on('click', '.slider-nav-button', function (e) {
    //         slider.pause();
    //         slider.play();
    //         slider.goTo($(this).data('direction'));
    //     });
    // }

    // components/Main.js - Client logos Tiny Slider (deferred to onload)
    $(window).on('load', function () {
        if ($(".clientcarousel").length) {
            var clientSlider = tns({
                container: '.clientcarousel',
                items: 3,
                loop: true,
                mode: 'carousel',
                slideBy: 'page',
                speed: 1000,
                nav: false,
                autoplayButtonOutput: false,
                controls: false,
                mouseDrag: true,
                autoplay: true,
                "responsive": {
                    "600": {
                        "items": 4
                    },
                    "1024": {
                        "items": 6
                    }
                },
            });
        }
    });

    // RENDER 'INFOGRAPH' for
    $('.chart-pie').each(function (){
        const sourceData = $(this).data('content');
        const sourceKeys = Object.keys(sourceData);
        const sourceValues = Object.values(sourceData);
        // Object.values(sourceData).forEach(value => sourceVals.push(parseInt(value)));
        let colors = [];
        sourceKeys.forEach((item, index, array) => {
            let shade = 10 + 245 / array.length * index;
            colors.push(`rgb(${shade},${shade},${shade})`);
        });
        const myChart = new Chart(
            this,
            {
                type: 'pie',
                data: {
                    labels: sourceKeys,
                    datasets: [{
                        label: '',
                        data: sourceValues,
                        backgroundColor: colors,
                        hoverOffset: 4,
                        borderWidth: 1,
                        radius: '95%',
                    }]
                },
            }
        );
    });

    // PANORAMA/VIRTUALTOUR VIEWER (deferred to onload)
    $(window).on('load', function () {
        $('#virtour').each(function () {
            // console.log($(this).data('scenes'));
            let panoObj = pannellum.viewer('virtour', {
                // General config
                "autoLoad": true,
                "autoRotate": -2,
                "keyboardZoom": false,
                "mouseZoom": false, // do not 'capture' scroll event
                "strings": { // https://github.com/mpetroff/pannellum/blob/master/src/js/pannellum.js#L120
                    "loadingLabel": '&nbsp;\n', // remove 'loading', just show progressbar
                },
                // "showZoomCtrl": false,
                // "showControls": false,
                // "preview": $(this).data('preview'),

                // // Single panorama
                // "type": "equirectangular",
                // "panorama": $(this).data('panorama'),
                // // limit pitch (vertical panning)
                // // "vaov": 60, // phone-pano's cover about 60 degrees -> setting vaov on equirectangular type doesnt work as it should...
                // // "minPitch": 0, "maxPitch": 0, // avoid pitch altogether -> 0 doesn't work when combined with avoidShowingBackground
                // "minPitch": -30, "maxPitch": 30, // instead just set the min/max
                // "avoidShowingBackground": true, // auto-calculate min/max pitch -> only works when min/maxPitch are set -> ensures the pano will be zoomed on portrait view to prevent background/black

                // // Cubemap tryout
                // "type": "cubemap",
                // "cubeMap": [
                //     "/images/wyman-park-playground-cubic/face0.jpg",
                //     "/images/wyman-park-playground-cubic/face1.jpg",
                //     "/images/wyman-park-playground-cubic/face2.jpg",
                //     "/images/wyman-park-playground-cubic/face3.jpg",
                //     "/images/wyman-park-playground-cubic/face4.jpg",
                //     "/images/wyman-park-playground-cubic/face5.jpg"
                // ],

                // // Single panorama with some hotspots: https://pannellum.org/documentation/reference/#hotspots-object
                // "hotSpotDebug": true, // Uncomment to print the coordinates of mouse clicks to the console
                // "hotSpots": [
                //     { // info link (with or without URL)
                //         "pitch": 14.1,
                //         "yaw": 1.5,
                //         "type": "info",
                //         "text": "Baltimore Museum of Art",
                //         "URL": "https://artbma.org/"
                //     },
                //         { // go to another scene-hotspot
                //             "pitch": -2.1,
                //             "yaw": 132.9,
                //             "type": "scene",
                //             "text": "Spring House or Dairy",
                //             "sceneId": "house"
                //         }
                // ]

                // Multiple scenes
                "default": {
                    // "autoLoad": true,
                    // "autoRotate": -1,
                    // "showControls": false,
                    // "mouseZoom": false,
                    // "keyboardZoom": false,
                    // "setPitchBounds": [],
                    "firstScene": $(this).data('firstscene'),
                },
                "scenes": $(this).data('scenes')
            });
            $(this).parents('.block-holder').find('.virtour-navlink').on('click', function (e) {
                e.preventDefault();
                panoObj.loadScene($(this).data('scene'));
            })
        });
    });

    ///// RESTORE SOME 'OLD' FUNCTIONALITY FROM THE PREVIOUS THEME /////

    /// set srcs (from data-src) and start playing videos
    if ($('.vidcropper').is(':visible')) {
        $('source[data-src]').each(function(){
            $(this).attr('src', $(this).data('src')).removeAttr('data-src');
        });
        window.setTimeout(function(){
            var vidEl = $('.vidcropper video');
            if(vidEl.length) {
                var vidHtml = vidEl.get(0).outerHTML;
                vidEl.remove();
                $('.vidcropper').html(vidHtml);
                $('.vidcropper video').get(0).play();
            }
        }, 1000);

    }

    // /// Some stuff for the vacancy pages...
    // $(window).on('resize load', function (){
    //     if($(window).width() < 992){
    //         $('.grow-full-height').height('auto');
    //     } else {
    //         $('.grow-full-height').each(function(){
    //             $(this).height( $(this).parent().height() );
    //         });
    //     }
    // });


    /// OpenDays tweaks: hide past dates on initial loading
    if($('body').hasClass('OpenDayHolder')
        // && (
        //     window.location.href.indexOf("shownext=") > -1
        // )
        && window.location.href.indexOf("start=") === -1
        && window.location.href.indexOf("date=") === -1
    ){
        $('.itemList .itemsum.in-past:not(.single-item)').hide();
    }
    // Clear postcode field
    $('.btn-clearfield').on('click', function (event){
        event.preventDefault();
        $(this).prev().val(null).focus();
    });
    // Reverse date order in filter dropdown: newest first
    var list = $('#opendayfilterform select');
    var listItems = list.children('option').not(":first");
    list.append(listItems.get().reverse());


    // /// Start client slider -> 2021 replaced by Tiny Slider?
    // var $clients = $(".clientcarousel");
    // if($clients.length){
    //     $(".clientcarousel").owlCarousel({
    //         //autoWidth: true,
    //         //margin:81,
    //         loop: true,
    //         center: true,
    //         autoplayTimeout: 1200,
    //         autoplay: true,
    //         //autoplaySpeed: 800,
    //         //items:6,
    //         //slideBy: 4,
    //         //itemsDesktop : [1024,4],
    //         //itemsDesktopSmall : [600,2],
    //         responsive : {
    //             // breakpoint from 0 up
    //             0 : {
    //                 items:3,
    //                 slideBy: 2,
    //             },
    //             // breakpoint from 480 up
    //             600 : {
    //                 items:4,
    //                 slideBy: 3,
    //             },
    //             // breakpoint from 768 up
    //             1024 : {
    //                 items:6,
    //                 slideBy: 4,
    //             }
    //         }
    //     });
    // }


    /// masterclass-registerform tweaks
    var mcForm = $('form.masterclass-registerform');
    if(mcForm.length){
        var guestNamesLabel = $('#Form_register_PersonGuestNames_Holder label');
        var guestNamesLabelText = guestNamesLabel.text();
        var dinnerAmountLabel = $('#Form_register_DinnerAmount_Holder label');
        var dinnerAmountLabelText = dinnerAmountLabel.text();
        $('input[name="DinerAmount"]', mcForm).attr('max', 1);
        mcForm.on('change', 'input[name="PersonGuestNames[]"]', function () {
            var total = 1 + $('input[name="PersonGuestNames[]"]', mcForm).filter(function () {
                return this.value.length > 0
            }).length;
            $('input[name="PersonTotalAmount"]', mcForm).val(total);
            $('input[name="DinnerAmount"]', mcForm).attr('max', total);
            guestNamesLabel.html( guestNamesLabelText + ' <span>(TOTAAL '+total+'p.)</span>' );
            dinnerAmountLabel.html( dinnerAmountLabelText + ' <span>(van totaal '+total+'p.)</span>' );
        });
        mcForm.on('submit', function (e) {
            var dateDrd = $('#GildeProgramRunID', mcForm);
            if(!dateDrd.val()){
                // dateDrd.parents('.middleColumn').addClass('holder-validation');
                dateDrd.after('<span class="message validation">Selecteer een locatie/datum</span>');
                e.preventDefault();
                window.location.hash = 'Form_register';
            } else {
                // 09-01-2020 17:00, AMSTERDAM
                var runDate = $('option[value="'+dateDrd.val()+'"]').text().split(', ');
                if(runDate.length==2){
                    $('input[name="ProgramRunDate"]').val(runDate[0]);
                    $('input[name="ProgramRunLocation"]').val(runDate[1]);
                }
            }
        });
    }

}(jQuery));

